/**
 * Small formatting helpers shared across screens. Keep this thin — date-fns
 * is already a dep and exposes more powerful primitives when needed.
 */
import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

export function formatDateShort(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'd MMM, HH:mm');
  } catch {
    return '—';
  }
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    const date = parseISO(iso);
    const distance = formatDistanceToNowStrict(date, { addSuffix: true });
    return distance;
  } catch {
    return '—';
  }
}

export function formatPrizePool(
  pool: ReadonlyArray<{ amount?: number }> | undefined,
): string | null {
  if (!pool?.length) return null;
  const total = pool.reduce((sum, slot) => sum + (slot.amount ?? 0), 0);
  if (!total) return null;
  return `${total.toLocaleString('en-US')} pts`;
}
